import { render } from "./Instagram.vue?vue&type=template&id=346d572c"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"
script.render = render

export default script